import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'
import { $steamUserData } from '@/entities/platforms/steam/store'
function useGetRefreshingStatus() {
  const profile = useUnit($steamUserData)

  const [isEpicRefreshing, setIsEpicRefreshing] = useState(false)
  const [isSteamRefreshing, setIsSteamRefreshing] = useState(false)

  useEffect(() => {
    if (!profile) {
      setIsEpicRefreshing(true)
      setIsSteamRefreshing(true)
    }
    if (profile?.userData?.epic_update_in_progress === true) {
      setIsEpicRefreshing(true)
    }
    if (profile?.userData?.steam_update_in_progress === true) {
      setIsSteamRefreshing(true)
    }
    if (profile?.userData?.epic_update_in_progress === false) {
      setIsEpicRefreshing(false)
    }
    if (profile?.userData?.steam_update_in_progress === false) {
      setIsSteamRefreshing(false)
    }
  }, [profile])
  return { isEpicRefreshing, isSteamRefreshing }
}

export default useGetRefreshingStatus
